import React, { useState, useEffect } from 'react';
import { MDBBtn, MDBInput, MDBRow, MDBTable } from 'mdb-react-ui-kit';
import TableHeader from '../../../components/table/TableHeader';
import TableBody from '../../../components/table/TableBody';
import '../../../components/MusButton.css';
import Alert from '../../../components/Alert';
import TorneoStore from '../../../stores/TorneoStore';
import RoundSelector from '../round-selector/RoundSelector';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { printMatchs } from "./printMatch";
import MusUtils from '../../../utils/Utilities';
import './RondaPage.css';


export default function RoundPage({torneoEnCurso, onChange, setAllowedContinue, onRoundNumChange}) {
  const [torneo, setTorneo] = useState(torneoEnCurso);
  const [roundNum, setRoundNum] = useState(() => torneoEnCurso.roundNum ? torneoEnCurso.roundNum : 1);
  const [allowedSave, setAllowedSave] = useState(true);
  const [showWinner, setShowWinner] = useState("");
  const [hiddeColumns, setHiddeColumns] = useState();
  const [isMaximized, setIsMaximized] = useState(false);
  const [isInitialized, setIsInitialized] = useState(true);
  // const [hiddeColumnsBool, setHiddeColumnsBool] = useState(false);

  let theme = MusUtils.getTheme();

  useEffect(() => {
    setHiddeColumns(window.innerWidth < 1024 ? 'none':'table-cell');
    // setHiddeColumnsBool(hiddeColumns === 'none');
  });

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  useEffect(() => {
    setTorneo(torneoEnCurso);
    // Sincronizar roundNum cuando el torneo cambia (al avanzar ronda)
    if (torneoEnCurso.roundNum && torneoEnCurso.roundNum > 0) {
      setRoundNum(torneoEnCurso.roundNum);
    }
  },[torneoEnCurso]);

  const handleMaximize = () => {
    setIsMaximized(true);
  };

  const handleRestore = () => {
    setIsMaximized(false);
  };

  const print = () => {
    let docContent = [];
    torneo.roundResults[roundNum-1].map((itemResults, indexMesa) => {
      // let aux = printMatchs(roundNum, indexMesa, itemResults.ids[0], itemResults.players[0], itemResults.ids[1], itemResults.player[1] );
      // let aux = [{"test": 1, "test2": 2}];
      let aux = itemResults.ids.length === 1 ? 
        printMatchs(torneo.name, roundNum, torneo.roundResults[roundNum-1].length, indexMesa + 1, itemResults.ids[0], itemResults.players[0], "", "") :
        printMatchs(torneo.name, roundNum, torneo.roundResults[roundNum-1].length, indexMesa + 1, itemResults.ids[0], itemResults.players[0], itemResults.ids[1], itemResults.players[1]);
      docContent = docContent.concat(aux);
    });

    let docDefinition = {
      content: docContent,
      styles: {
        top1: {
          margin: [0, 0, 0, 0],
        },
        top2: {
          margin: [0, 0, 0, 2],
        },
        top3: {
          margin: [0, 0, 0, 6],
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
        },
        subheader: {
          fontSize: 14,
          bold: true,
          margin: [0, 10, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 5],
        },
        firma: {
          margin: [0, 0, 0, 43],
        }
      },
    };

    pdfMake.createPdf(docDefinition).open({}, window.open('', '_blank'));
  }

  const saveRoundResults = () => {  
    // Solo guardar y recalcular si todos los resultados están completos
    if (!isAllResultsFilled(torneo)) {
      setTorneo({...torneo});
      TorneoStore.getInstance().saveTorneo(torneo);    
      // Opcional: muestra un mensaje de error o alerta
      return;
    }

    let torneoAux = torneo;
    torneoAux.doublets.map((itemDoublets) => {
      itemDoublets.earned=0;
      itemDoublets.losses=0;
      itemDoublets.exents=0;
      itemDoublets.pointsPositive=0;
      itemDoublets.pointsNegative=0;
      itemDoublets.position=0;
    })
    torneoAux.roundResults.map((itemRoundResults, indexRound) => {
      if (indexRound + 1 <= roundNum) {
        let exentoId = getExento(indexRound + 1);
        if (exentoId) {
          torneoAux.doublets.map((item) => {
            if (item.id === exentoId) {
              item.exents++;
              item.pointsPositive = item.pointsPositive + torneo.numJuegos;
            }
          });
        }
      }
    });
    torneoAux.roundResults.map((itemRoundResults, indexRound) => {
      if (indexRound + 1 <= roundNum) {
        itemRoundResults.map((itemResults) => {
          if (itemResults.ids[0] && itemResults.ids[1]) {
            torneoAux.doublets.map((itemDoublets) => {
              if (itemDoublets.id === itemResults.ids[0]) {
                itemDoublets.status = "Continua";
                if (itemResults.points[0] > itemResults.points[1]) itemDoublets.earned++;
                else itemDoublets.losses++;
                itemDoublets.pointsPositive += itemResults.points[0];
                itemDoublets.pointsNegative += itemResults.points[1];
                // Eliminatoria
                if (
                  torneoAux.championType.indexOf('Eliminatoria') !== -1 &&
                  itemDoublets.losses + 1 > torneoAux.numZeros
                ) {
                  itemDoublets.status = "Eliminado";
                  itemDoublets.elminateOnRound = indexRound;
                }
              }
              if (itemDoublets.id === itemResults.ids[1]) {
                itemDoublets.status = "Continua";
                if (itemResults.points[1] > itemResults.points[0]) itemDoublets.earned++;
                else itemDoublets.losses++;
                itemDoublets.pointsPositive += itemResults.points[1];
                itemDoublets.pointsNegative += itemResults.points[0];
                // Eliminatoria
                if (
                  torneoAux.championType.indexOf('Eliminatoria') !== -1 &&
                  itemDoublets.losses + 1 > torneoAux.numZeros
                ) {
                  itemDoublets.status = "Eliminado";
                  itemDoublets.elminateOnRound = indexRound;
                }
              }
            });
          }
        })
      }
    });

    // Sort doublets
    let doubletSorted = torneoAux.doublets.sort((a, b) => { 
      // primero por partidas ganadas
      let result = (b.earned + b.exents) - (a.earned + a.exents); 
      if (result === 0) {
        // luego por la diferencia entre puntos a favor y en contra (cuanto mayor sea, mejor)
        result = (b.pointsPositive - b.pointsNegative) - (a.pointsPositive - a.pointsNegative); 
        if (result === 0) {
          // luego por puntos a favor
          result = b.pointsPositive - a.pointsPositive; 
          if (result === 0) {
            // luego por exentos
            result = a.exents - b.exents; 
            if (result === 0) {
              // finalmente por id
              result = a.id - b.id; 
            }
          }
        }
      }
      return result;
    });

    // Get the clasification order
    let _position = 1;
    doubletSorted.map((item) => {
      item.position = _position;
      _position++;
    });
    torneoAux.doublets = doubletSorted;

    let doubletsPlaying = torneoAux.doublets.filter((itemDoublets) => 
      itemDoublets.status === "Continua"
    );

    if (isAllResultsFilled(torneo)) {
      setAllowedContinue(true);
      if (doubletsPlaying.length === 1) {
        torneoAux.status = "Finalizado";
        // alert("Torneo Finalizado. El ganador es el equipo " + doubletsPlaying[0].nameDoublet);
        setShowWinner("El ganador es el equipo " + doubletsPlaying[0].nameDoublet);
      }
    }

    setTorneo({...torneoAux});
    TorneoStore.getInstance().saveTorneo(torneoAux);    
  }

  const getExento = (roundNumAux) => {
    let result = undefined;
    if (roundNumAux > 0 && torneo.roundResults && torneo.roundResults.length > 0) {
      if (torneo.roundResults[roundNumAux-1]) {
        torneo.roundResults[roundNumAux-1].map((item) => {
          if (item && item.ids[0] && !item.ids[1]) {
            result = item.ids[0]
          }
        })
      }
    }
    return result;
  }
  
  const isResultValid = (points) => {
    if (points[0] === '' || 
        points[0] > torneo.numJuegos ||
        points[0] < 0 ||
        points[1] ==='' || 
        points[1] > torneo.numJuegos ||
        points[1] < 0 ||
        (points[0] === torneo.numJuegos && points[1] === torneo.numJuegos) ||
        (points[0] !== torneo.numJuegos && points[1] !== torneo.numJuegos)) {
      return false;
    }
    return true
  }

  const isAllResultsFilled = (torneo) => {
    let _isAllowed = true;
    if (torneo.status!=="Finalizado") {
      if (roundNum > 0 && torneo.roundResults && torneo.roundResults[roundNum-1])
        torneo.roundResults[roundNum-1].map((itemResults, indexMesa) => {
          if (!isResultValid(itemResults.points)) {
            _isAllowed = false;
            setAllowedContinue(false);
          } 
        })
    } else {
      _isAllowed = false;
    }
    return _isAllowed;
  }

  const getCellBackground = (itemResults, colName, exento) => {
    let darkgrayBackground = 'darkgray';
    let lightgrayBackground = 'lightgray';
    if (theme === 'dark') {
      darkgrayBackground = '#1d2b4d';
      lightgrayBackground = '#274a82';
    }

    if (colName === 'Mesa') {
      return darkgrayBackground
    } else if (colName === 'Nº' ) {
      return exento ? darkgrayBackground : lightgrayBackground
    } else if (!isResultValid(itemResults.points)) {
      if (colName.indexOf('Pareja') === -1)
        return darkgrayBackground
      else
        return lightgrayBackground
    } else if (colName === 'Pareja 1') {
      return exento ? darkgrayBackground : itemResults.points[0]>itemResults.points[1] ? 'green' : 'red'
    } else if (colName === 'Pareja 2') {
      return exento ? darkgrayBackground : itemResults.points[0]<itemResults.points[1] ? 'green' : 'red'
    } else if (colName === 'Puntos') {
      return exento ? darkgrayBackground : lightgrayBackground
    }
  }

  const getCellBorder = (itemResults) => {
    // if (!isResultValid(itemResults.points)) {
    //   return 'red'
    // } else {
      return 'inherit';
    // }
}

  const getStyles = (itemResults, colName) => {
    let background = getExento(roundNum) === itemResults.ids[0] ? getCellBackground(itemResults, colName, 'true') : getCellBackground(itemResults, colName);
    let newStyle = {
      border: getCellBorder(itemResults),
      color:  (theme==="dark" || background.indexOf("green") !== -1 ||  background.indexOf("red") !== -1) ? "white" : "black", 
      background: background,
    }

    if (colName === "Pareja 1" || colName === "Pareja 2") {
      newStyle = {textWrap:'nowrap', textOverflow:'ellipsis', overflow:'hidden', mimWidth:"70px", maxWidth:"50%",  ...newStyle};
    } else if (colName!=='Puntos') {
      newStyle = {display:hiddeColumns, ...newStyle}
    }

    return newStyle;
  }
  
  const getWinner = (itemResults) => {
    if (itemResults.points[0] && itemResults.points[1]) {
      return itemResults.points[0]>itemResults.points[1] ? itemResults.ids[0] : itemResults.ids[1]
    } else {
      return ''
    }
  }
  
  const onRoundChange = num => {
    setRoundNum(num);
    if (onRoundNumChange) onRoundNumChange(num);
    // setAllowedSave(num <= torneo.roundNum);
    setAllowedSave(num == torneo.roundNum);

  }
  
  const closeAlert = () => {
    setShowWinner("");
  }

  return (
    torneo && torneo.roundResults ? <>
      <div className={`ronda ${isMaximized ? 'maximized' : ''}`}>
        <Alert
              show={showWinner !== ""}
              setShow={setShowWinner}
              title="Torneo Finalizado"
              message={showWinner}style={{marginRight:'10px'}} 
              closeAction={closeAlert}
        ></Alert>
        <MDBRow>
          <div className='d-flex flex-wrap justify-content-start p-3 col-lg-8 col-md-12'>
            <RoundSelector torneo={torneo} onRoundChange={onRoundChange} roundNumSelected={roundNum}/>
          </div>
          <div className='d-flex flex-wrap justify-content-end p-3 col-lg-4 col-md-12'>
            <MDBBtn className='musButton-xm' style={{marginRight:'10px'}} onClick={()=>{print()}}>
              Imprimir
            </MDBBtn>
            <MDBBtn className='musButton-xm' style={{marginRight:'10px'}} onClick={()=>{saveRoundResults()}} disabled={!allowedSave}>
              Grabar
            </MDBBtn>
            {isMaximized ? (
              <MDBBtn className="musButton-xm-icon" onClick={handleRestore}>
                <i className="fas fa-compress"></i>
              </MDBBtn>
            ) : (
              <MDBBtn className="musButton-xm-icon" onClick={handleMaximize}>
                <i className="fas fa-expand"></i>
              </MDBBtn>
            )}
          </div>
        </MDBRow>

        <MDBTable align='middle'>
          <TableHeader light>
            <tr>
              <th colSpan={7} className='text-center'>Enfrentamientos</th>
            </tr>
            <tr>
              <th style={{width:'50px', display:hiddeColumns}} className='text-center text-mesa header'>__MESA__</th>
              <th style={{width:'50px', display:hiddeColumns}} className='text-center'>Nº</th>
              <th style={{width:'50%'}} >Pareja 1</th> 
              <th style={{width:'50px'}} className='text-center'>Puntos</th>
              <th style={{width:'50px', display:hiddeColumns}} className='text-center'>Nº</th>
              <th style={{width:'50%'}} >Pareja 2</th> 
              <th style={{width:'50px'}} className='text-center'>Puntos</th>
            </tr>
          </TableHeader>
          {roundNum > 0 && torneo.roundResults && torneo.roundResults[roundNum-1] &&
            <>
              {torneo.roundResults[roundNum-1].map((itemResults, indexMesa) => {
                return (
                  <TableBody>
                        <tr>
                          <td style={getStyles(itemResults,'Mesa')} className='text-center text-mesa'>{indexMesa + 1}</td>
                          <td style={getStyles(itemResults,'Nº')} className='text-center'>{itemResults.ids[0]}</td>
                          {/* <td style={{background: (getExento(roundNum) === itemResults.ids[0] ? 'lightgray' : getCellBackground(itemResults,'Pareja 1'))}}>{itemResults.players[0]}</td>
                          <td style={{background: (getExento(roundNum) === itemResults.ids[0] ? 'lightgray' : 'white')}}>{ */}
                          <td className='NoBackground' style={getStyles(itemResults,'Pareja 1')}>{itemResults.players[0]}<span className="tooltip">{itemResults.players[0]}</span></td>
                          <td style={getStyles(itemResults,'Puntos')}>{
                            <MDBInput 
                              type='number' 
                              value={itemResults.points[0]} 
                              onChange={(e)=>{onChange(torneo, roundNum-1, 0, indexMesa, e.target.value, itemResults)}} 
                              disabled={getExento(roundNum) === itemResults.ids[0] || roundNum !== torneo.roundNum}
                              className={getExento(roundNum) === itemResults.ids[0] || roundNum !== torneo.roundNum ? 'disabled' : ''}/>
                          }</td>
                          <td style={getStyles(itemResults,'Nº')} className='text-center'>{itemResults.ids[1]}</td>
                          <td style={getStyles(itemResults,'Pareja 2')}>{itemResults.players[1]}</td>
                          <td style={getStyles(itemResults,'Puntos')}>{
                            <MDBInput 
                              type='number' 
                              value={itemResults.points[1]} 
                              onChange={(e)=>{onChange(torneo, roundNum-1, 1, indexMesa, e.target.value, itemResults)}} 
                              disabled={getExento(roundNum) === itemResults.ids[0] || roundNum !== torneo.roundNum}
                              className={getExento(roundNum) === itemResults.ids[0] || roundNum !== torneo.roundNum ? 'disabled-input' : 'enabled-input'}/>
                          }</td>
                        </tr>
                  </TableBody>
                )
              })}
            </>
          } 
        </MDBTable>
        {getExento(roundNum) && <span>{getExento(roundNum) ? '(*) Pareja Exenta: ' + getExento(roundNum) : ''}</span>}
      </div>
    </> : <div>"PENDING SAVE MATCH GENERATED BY ELIMINATORY PROPERLY ON DEFINED STRUCTURE"</div>
  );
}
